import { ComponentProps } from 'react';

const BordMascotIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg viewBox="0 0 22 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.4405 0.333496H10.9042C8.34938 0.333496 6.0073 1.2393 4.18068 2.74689C1.83109 4.68612 0.333496 7.61998 0.333496 10.9042C0.333496 13.4589 1.2393 15.801 2.74689 17.6276C3.17727 18.1493 3.65771 18.6298 4.17942 19.0602C6.0073 20.5677 8.34938 21.4736 10.9029 21.4736C14.1871 21.4736 17.1209 19.976 19.0602 17.6264C20.5677 15.7985 21.4736 13.4564 21.4736 10.9029V2.36781C21.4736 1.24431 20.5627 0.333496 19.438 0.333496H19.4405Z"
        fill="url(#paint0_radial_21460_889)"
      />
      <ellipse cx="9.02585" cy="8.3725" rx="1.3071" ry="2.61419" fill="#1B202F" />
      <ellipse cx="12.9472" cy="8.69904" rx="1.3071" ry="2.28742" fill="#1B202F" />
      <ellipse cx="5.43176" cy="12.6207" rx="0.326775" ry="0.326774" fill="#1B202F" />
      <ellipse cx="10.9867" cy="18.8291" rx="5.22839" ry="1.3071" fill="#1B202F" />
      <path
        d="M10.9569 19.0542L11.044 19.0899C11.2367 19.191 11.346 19.4093 11.3022 19.6299L10.1807 25.2663C10.1296 25.5235 9.88879 25.6973 9.62863 25.6648L4.853 25.0656C4.69982 25.0462 4.56607 24.9571 4.48775 24.8268L4.45749 24.7686C4.21782 24.217 4.03784 23.2817 4.63028 22.5744C5.16164 21.9402 6.14871 21.6897 7.65302 21.8898L7.77043 18.7406C7.77624 18.5857 7.8543 18.4424 7.98049 18.3524C8.10683 18.2624 8.26828 18.2358 8.41667 18.281L10.9569 19.0542Z"
        fill="#22CFAB"
        stroke="#1B202F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3364 19.3952L11.2521 19.4373C11.0675 19.5525 10.9748 19.7784 11.0349 19.9951L12.5739 25.5321C12.6441 25.7848 12.8972 25.9402 13.1542 25.8883L17.8718 24.9344C18.0231 24.9036 18.1499 24.8048 18.2182 24.669L18.2441 24.6087C18.4419 24.0407 18.5516 23.0946 17.908 22.4335C17.3308 21.8407 16.3278 21.6646 14.8426 21.9764L14.4905 18.8448C14.4732 18.6907 14.3846 18.5536 14.2521 18.4733C14.1194 18.3929 13.9564 18.3785 13.8118 18.4346L11.3364 19.3952Z"
        fill="#22CFAB"
        stroke="#1B202F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9312 14.4704C8.64687 14.7941 10.7018 15.2062 13.1963 14.2655C15.6907 13.3247 16.8176 12.1235 17.0692 11.6404"
        stroke="#1B202F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_21460_889"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.1795 5.94883) rotate(112.011) scale(16.7453 16.7453)"
        >
          <stop offset="0.665" stopColor="#22CFAB" />
          <stop offset="1" stopColor="#1AA185" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default BordMascotIcon;
